import { Note, SortedNotes } from '../../redux/store/api/api';
import { VERSION_CONTENT_CONTAINER_ID } from '../../shared/constants';
import { VisibilityGroupString } from './types';

type NoteDataProperty = 'userNotes' | 'userGroupNotes' | 'generalNotes';

export const getSortedNotesPropertyByVisibilityGroup = (
  visibilityGroup: VisibilityGroupString | null,
): NoteDataProperty | undefined => {
  if (!visibilityGroup) {
    return undefined;
  }

  const firstLetterUpperCase = visibilityGroup[0];
  const firstLetterLowerCase = firstLetterUpperCase.toLocaleLowerCase();
  return `${visibilityGroup.replace(
    firstLetterUpperCase,
    firstLetterLowerCase,
  )}Notes` as NoteDataProperty;
};

export const getNotesByVisibilityGroup = (
  visibilityGroup: VisibilityGroupString | null,
  noteData: SortedNotes,
): Note[] => {
  switch (visibilityGroup) {
    case 'User':
      return noteData.userNotes || [];
    case 'UserGroup':
      return noteData.userGroupNotes || [];
    case 'General':
      return noteData.generalNotes || [];
    default:
      return [];
  }
};

export const scrollMarkIntoView = (note: Note) => {
  if (!note.mark?.id) {
    return;
  }

  const markEl: Element | null = document.querySelector(
    `[id*=${CSS.escape(note.mark.id)}]`,
  );
  if (markEl) {
    markEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export const getFirstWords = (fullText: string | null | undefined) => {
  if (!fullText) {
    return undefined;
  }

  const maxWords = 5;
  return fullText.split(/\s/g).slice(0, maxWords).join(' ');
};

export const getMarkIsError = (note: Note) => {
  const contentContainer = document.getElementById(
    VERSION_CONTENT_CONTAINER_ID,
  );

  return note.mark?.id
    ? contentContainer &&
        !contentContainer.querySelector(`[id*=${CSS.escape(note.mark.id)}]`) &&
        !note.mark?.markInvalid
    : true;
};

export const getNotesForAccordionList = (notes: Note[]) =>
  notes.filter(
    (note) =>
      !note.mark ||
      (note.text?.length ?? 0) > 0 ||
      note.mark.markInvalid ||
      getMarkIsError(note),
  );
